import React, { Component } from "react";
import { Breadcrumb, Button, Form, Row, Col, List, Schema, toaster, Message } from "rsuite";
import styled from "styled-components";
import ArrowLeftLineIcon from "@rsuite/icons/ArrowLeftLine";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { DevicesSelector } from "../redux/selector";
import { SetDevices, SetSelectedDevice } from "../redux/actions";
import TrashIcon from "@rsuite/icons/Trash";
import AddDeviceComponent from "./add.device";

const Container = styled.div`
  width: 100%;
  a {
    text-decoration: none;
    color: unset;
  }
`;
const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
const TableDiv = styled.div`
  width: 100%;
`;
const Item = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 7px;
`;

class ManageDeviceComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddForm: false,
    };
  }

  render() {
    const { showAddForm } = this.state;
    const { devices, setDevices, setSelectedDevice, handleBack } = this.props;
    return (
      <Container>
        <Breadcrumb separator={<ArrowLeftLineIcon />}>
          <Breadcrumb.Item
            style={{ color: "#f07d00" }}
            onClick={() => handleBack()}
          >
            تنظیمات
          </Breadcrumb.Item>
          <Breadcrumb.Item>مدیریت دستگاه ها</Breadcrumb.Item>
        </Breadcrumb>
        <Content>
          {showAddForm ? (
            <AddDeviceComponent inForce={false} setShowForm={(showAddForm)=>this.setState({showAddForm})} />
          ) : (
            <TableDiv>
              <List>
                <List.Item>
                  <Item>
                    <span>نام</span>
                    <span>شماره دستگاه</span>
                    <span>حذف</span>
                  </Item>
                </List.Item>
                {!!devices.length &&
                  devices.map((item, i) => (
                    <List.Item key={i}>
                      <Item>
                        <span>{item.name || "-"}</span>
                        <span>{item.mobile}</span>
                        {/* handleDelete Device */}
                        <TrashIcon
                          onClick={() => {
                            if(devices.length <= 1) {
                              toaster.push(<Message full showIcon type="error">وجود یک دستگاه اجباری است</Message>)
                            }else {
                              setDevices(devices.filter((it) => it !== item));
                              setSelectedDevice("");
                            }
                          }}
                        />
                      </Item>
                    </List.Item>
                  ))}
              </List>
              <Button
                block
                onClick={() => this.setState({ showAddForm: true })}
                appearance="primary"
                color="orange"
              >
                افزودن
              </Button>
            </TableDiv>
          )}
        </Content>
      </Container>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  devices: DevicesSelector,
});
const mapDiapatchToProps = (dispatch) => ({
  setDevices: (data) => dispatch(SetDevices(data)),
  setSelectedDevice: (device) => dispatch(SetSelectedDevice(device)),
});

export default connect(
  mapStateToProps,
  mapDiapatchToProps
)(ManageDeviceComponent);
